export const getInvoiceCheckPath = () => '/c/:token';
